<template>
  <div
    id="app"
    class="app"
  >
    <div class="langbar">
      <div class="inline-flex">
        <Button
          class="bg-white mr-1"
          :class="mapClassEs"
          @click="switchLang('es')"
        >
          ES
        </Button>
        <Button
          class="bg-white mr-1"
          :class="mapClassEu"
          @click="switchLang('eu')"
        >
          EU
        </Button>
        <Button
          class="bg-white mr-1"
          :class="mapClassEn"
          @click="switchLang('en')"
        >
          EN
        </Button>
        <Button
          class="bg-white"
          :class="mapClassFr"
          @click="switchLang('fr')"
        >
          FR
        </Button>
      </div>
    </div>
    <router-view />
  </div>
</template>

<!--
<i18n>
{
  es: {
    meta: {
      title: 'Mapa de las Religiones de Euskadi',
    },
  },
  eu: {
    meta: {
      title: 'Mapa de las Religiones de Euskadi',
    },
  },
  en: {
    meta: {
      title: 'Mapa de las Religiones de Euskadi',
    },
  },
  fr: {
    meta: {
      title: 'Mapa de las Religiones de Euskadi',
    },
  },
}
</i18n>
-->

<script>

import Button from './components/common/Button'

export default {
  components: {
    Button,
  },
  data () {
    return {
      locale: 'es',
    }
  },
  computed: {
    mapClassEs () {
      return (this.$i18n.locale === 'es') ? 'active' : ''
    },
    mapClassEu () {
      return (this.$i18n.locale === 'eu') ? 'active' : ''
    },
    mapClassEn () {
      return (this.$i18n.locale === 'en') ? 'active' : ''
    },
    mapClassFr () {
      return (this.$i18n.locale === 'fr') ? 'active' : ''
    },
  },
  mounted () {
    this.setMetaTitle()
  },
  methods: {
    switchLang (ln) {
      this.$i18n.locale = ln
      this.setMetaTitle()
      this.$router.replace({
        path: '/' + ln,
      }).catch(err => {
        console.log(err)
      })
    },
    setMetaTitle () {
      document.title = 'Ikuspegi | ' + this.$t('title')
      // Iterate Nodelist
      const meta = document.getElementsByTagName('meta')
      const desc = this.$t('desc')
      Array.prototype.forEach.call(meta, function (el, i) {
        if (el.name.toLowerCase() === 'description') {
          el.content = desc
        }
      })
    },
  },
}
</script>

<style lang="scss">

  $blue: rgb(83, 103, 128);
  $bluelight: rgb(173, 179, 187);
  $orange: rgb(252, 159, 77);

  .app {
    overflow-y: hidden;
    margin: 0;
    padding: 0;
    height: 100%;
  }

  .langbar {
    z-index: 9999;
    position: absolute;
    top: 1rem;
    right: 1rem;
  }

  /* Scrolbars */

  ::-moz-selection {
    background-color: $orange;
  }

  ::selection {
    background-color: $orange;
  }

  ::-webkit-scrollbar{
    width: 6px;
  }

  ::-webkit-scrollbar-track-piece{
    background-color: transparent;
  }

  ::-webkit-scrollbar-thumb{
    background-color: $blue;
    outline: 1px solid #FFF;
    outline-offset: -2px;
    border: .1px solid $blue;
  }

  ::-webkit-scrollbar-thumb:hover{
    background-color: #909090;
  }
</style>
